export default {
  resize: {
    transition: 'width 0.15s ease-in',
    width: '60em',
    minHeight: '23em',
    maxHeight: '80%',
    overflow: 'auto',
  },
}
